<template>
<div>

  <!-- TRAINEE VIEW -->
  <div class="the-navbar__user-meta flex items-center" v-if="(user_data && user_data.userType ==='trainee') || (activeUserInfo && activeUserInfo.userType==='trainee')">
    <div class="text-right leading-tight hidden sm:block"></div>
   <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-2 feather-icon">
        <img v-if="(user_data && user_data.avatar) || (activeUserInfo && activeUserInfo.avatar)" key="onlineImg" :src="(user_data && user_data.avatar) ? user_data.avatar : activeUserInfo.avatar" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
        <img v-else key="onlineImg" src="@/assets/images/profile/avatar.png" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>
      <vs-dropdown-menu class="vx-navbar-dropdown" style="width:200px;">
        <ul style="min-width: 9rem">
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/user/profile/view').catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('MyProfile')}}</span>
          </li>
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/user/my-skills').catch(() => {})">
            <feather-icon icon="ArchiveIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('MySkills')}}</span>
          </li>
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/user/my-coach/profile/view').catch(() => {})">
            <feather-icon icon="UserPlusIcon" svgClasses="w-4 h-4" />
            <span class="ml-2" v-if="companyName==='GALA.GAMES'" >My Mentor Profile</span>
            <span class="ml-2" v-else >{{$t('CoachProfile')}}</span>
          </li>
          <li class="flex py-2 px-4 cursor-pointer" title="Status" v-if="(organizationType==='Business' || organizationType==='Recruiter') && isCoachEligible">
            <feather-icon icon="DiscIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">
              <div class="grid-layout-container alignment-block ">
                <vs-row vs-align="flex-end" vs-type="flex" vs-justify="" vs-w="12">
                  <vs-switch color="success" v-model="userTypeStatus" name="userTypeStatus" @change="StatusSwitch">
                    <span slot="on">Coach</span>
                    <span slot="off">Trainee</span>
                  </vs-switch>
                </vs-row>
              </div>
            </span>
          </li>
          <vs-divider class="m-1" />
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('LogOut')}}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>

  <!-- COACH VIEW -->
  <div class="the-navbar__user-meta flex items-center" v-else-if="(user_data && user_data.userType ==='coach') || (activeUserInfo && activeUserInfo.userType==='coach')">
    <div class="text-right leading-tight hidden sm:block"></div>
   <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img v-if="(user_data && user_data.avatar) || (activeUserInfo && activeUserInfo.avatar)" key="onlineImg" :src="(user_data && user_data.avatar) ? user_data.avatar : activeUserInfo.avatar" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
        <img v-else key="onlineImg" src="@/assets/images/profile/avatar.png" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>
      <vs-dropdown-menu class="vx-navbar-dropdown" style="width:200px;">
        <ul style="min-width: 9rem">
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/user/profile/view').catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('MyProfile')}}</span>
          </li>
          <li class="flex py-2 px-4 cursor-pointer  " title="Status" v-if="organizationType==='Business' || organizationType==='Recruiter'"  >
            <feather-icon icon="DiscIcon" svgClasses="w-4 h-4" />
            <span class="ml-2" v-if="isCoachEligible">
                <div class="grid-layout-container alignment-block ">
              <vs-row vs-align="flex-end" vs-type="flex" vs-justify="" vs-w="12">
                <vs-switch  color="success" v-model="userTypeStatus"  name="userTypeStatus"  @change="StatusSwitch" >
                  <span  slot="on">Coach</span>
                  <span  slot="off" >Trainee</span>
                </vs-switch>
              </vs-row>
            </div>
            </span>
          </li>
          <vs-divider class="m-1" />
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('LogOut')}}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>

  <!-- ADMIN VIEW (Updated to call "logout" method) -->
  <div class="the-navbar__user-meta flex items-center" v-else-if="(user_data && user_data.userType ==='admin') || (activeUserInfo && activeUserInfo.userType==='admin')">
    <div class="text-right leading-tight hidden sm:block"></div>
   <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img key="onlineImg" v-if="activeUserInfo.avatar" :src="activeUserInfo.avatar" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
        <img v-else key="onlineImg" src="@/assets/images/profile/avatar.png" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>
      <vs-dropdown-menu class="vx-navbar-dropdown" style="width:200px;">
        <ul style="min-width: 9rem">
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('LogOut')}}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>

  <!-- FALLBACK VIEW (Updated to call "logout" method) -->
  <div class="the-navbar__user-meta flex items-center" v-else>
    <div class="text-right leading-tight hidden sm:block"></div>
   <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img key="onlineImg" v-if="activeUserInfo.avatar" :src="activeUserInfo.avatar" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
        <img v-else key="onlineImg" src="@/assets/images/profile/avatar.png" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>
      <vs-dropdown-menu class="vx-navbar-dropdown" style="width:200px;">
        <ul style="min-width: 9rem">
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('LogOut')}}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      user_data: null,
      organizationType:'',
      userTypeStatus:'',
      companyName:null
    };
  },
  computed: {
    userType() {
      let userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return userInfo.userType || '';
    },
    activeUserInfo () {
      return JSON.parse(localStorage.getItem('userInfo') || '{}');
    },
    // --- ADD THIS NEW COMPUTED PROPERTY ---
    isCoachEligible() {
      // 1. First, check if we have fresh data from the API/Database
      if (this.user_data && this.user_data.is_coach_eligible !== undefined) {
        // MySQL returns 1 for true, 0 for false. 
        return this.user_data.is_coach_eligible === 1 || this.user_data.is_coach_eligible === true;
      }
      
      // 2. Fallback: check LocalStorage in case it was saved during login
      if (this.activeUserInfo && this.activeUserInfo.is_coach_eligible !== undefined) {
        return this.activeUserInfo.is_coach_eligible === 1 || this.activeUserInfo.is_coach_eligible === true;
      }
      
      // 3. If the data isn't there, hide the toggle to be safe
      return false;
    }
    // --------------------------------------
  },
  mounted () {
    let userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    this.userTypeStatus = userInfo.userType === 'trainee' ? false : true;
    this.companyName = window.$cookies.get('companyName');
    this.organizationType = window.$cookies.get('organizationType');
  },
  methods: {
    StatusSwitch(){
      let userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      let payload = '';
      
      if(this.userTypeStatus === true){
        payload = { userType:'coach', id: userInfo.usersId }
        this.userTypeStatus = true;
      } else {
        payload = { userType:'trainee', id: userInfo.usersId }
        this.userTypeStatus = false;
      }

      // REMOVE THIS LINE: localStorage.removeItem('userInfo')

      this.$store
          .dispatch("userManagement/updateUser", payload)
          .then(res => {
            
            // This will now properly MERGE the new role with your existing name!
            this.$store.dispatch('updateUserInfo', {
              userType: payload.userType
            }).then(res=>{
              window.location.replace(`/`);
            });

            this.$vs.notify({
              color: "primary",
              title: this.$t("msg.msg1.suc_title"),
              text: this.$t("msg.msg1.suc_desc")
            });
          })
          .catch(err => {
            console.error(err);
            this.$vs.notify({
              color: "danger",
              title: this.$t("msg.msg1.err_title"),
              text: this.$t("msg.msg1.err_desc")
            });
          });
    },
    logout () {
      // 1. Log out via Auth0 or other custom plugin if present
      if (this.$auth && this.$auth.profile) {
        this.$auth.logOut();
      }

      // 2. Clear state variables to prevent template reactivity rendering issues
      this.user_data = null;

      // 3. Clear cookies
      if (window.$cookies) {
        window.$cookies.remove('companyId');
        window.$cookies.remove('companyName');
        window.$cookies.remove('enterpriseType');
        window.$cookies.remove('terminology');
      }

      // 4. Clear Local Storage items
      localStorage.removeItem('accessToken');
      localStorage.removeItem('feathers-jwt');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('themeColor');

      // 5. Update ACL permissions
      if (this.$acl) {
        this.$acl.change('admin');
      }

      // 6. Use window.location.replace to cleanly redirect to login.
      // This forces a complete DOM reset and prevents Vuesax from crashing during destruction.
      window.location.replace('/user/auth/login');
    }
  },
  created () {
    let usersId = '';
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    
    if(userInfo && userInfo.usersId){
       usersId = userInfo.usersId;
    } else if (this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.usersId) {
      usersId = this.$store.state.AppActiveUser.usersId;
    }

    if(usersId) {
      this.$store
        .dispatch("userManagement/fetchUser", usersId)
        .then(res => {
          this.user_data = res;
        })
        .catch(err => {
          if (err.response && err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error(err);
        });
    }
  }
}
</script>